import { Observable } from "rxjs";
import { UserInfo } from "../model/user-info";

export abstract class UserService {
    public abstract getUserName(): string | null;
    public abstract selectUserName(): Observable<string | null>
    public abstract setUserInfo(data: UserInfo): void;
    public abstract clearUserInfo(): void;
}
